import IconNameEnum from "constants/IconNameEnum";
import environment from "environment";
import IAction from "models/IAction";
import IStore from "models/IStore";
import React from "react";
import { Col, Nav } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import NavigationUtility from "utilities/NavigationUtility";
import BaseDropdown from "views/components/base-content/BaseDropdown";
import BaseModal from "views/components/base-content/BaseModal";
import BaseButton from "views/components/base-form/BaseButton";
import HeaderUtenteOperationEnum from "../../../../constants/HeaderUtenteOperationEnum";
import jwt_decode from "jwt-decode";
import FormatUtility from "utilities/FormatUtility";
import UtenteAction from "stores/utente/UtenteAction";
import RouteEnum from "constants/RouteEnum";
import ResponseAuthTokensModel from "stores/shared/models/ResponseAuthTokensModel";

interface IProps {}

interface IState {
    readonly isVisibleAlertLogOut: boolean;
    readonly isVisibleAvviso: boolean;
}

interface IStateToProps {
    readonly isRequesting: boolean;
    readonly isLogged: boolean;
    readonly userName: string;
    readonly userSurname: string;
    readonly descUO: string;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: false,
    isLogged: state.utente.profilo.isLogged,
    userName: state.utente.profilo.nome,
    userSurname: state.utente.profilo.cognome,
    descUO: state.utente.profilo.descUO,
});

class HeaderUtente extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);

        this.state = {
            isVisibleAlertLogOut: false,
            isVisibleAvviso: false,
        } as IState;
    }

    private hasUnmounted = false;

    // componentDidMount() {
    //     const { isLogged } = this.props;
    //     const accessToken = sessionStorage.getItem(environment.accessTokenName);
    //     if (isLogged && accessToken) {
    //         this.props.dispatch(UtenteAction.userInfoGet());
    //     }
    // }
    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private redirectToPage = (page: string) => {
        NavigationUtility.redirectToPage(page);
    };

    private getUserName = (): string => {
        const { isLogged } = this.props;
        const accessToken = sessionStorage.getItem(environment.accessTokenName);
        if (isLogged && accessToken) {
            const decoded: any = jwt_decode(accessToken);
            if (decoded.family_name && decoded.given_name) {
                return `${FormatUtility.capitalizeFirstLetter(
                    decoded.given_name
                )} ${FormatUtility.capitalizeFirstLetter(decoded.family_name)}`;
            }
            return "Nome Cognome";
        }
        return "Nome Cognome";
    };

    private getDescUo = (): string => {
        return sessionStorage.getItem(environment.descUoName) ?? "";
    };

    private onDropdownSelect = (code: string) => {
        switch (code) {
            case HeaderUtenteOperationEnum.Logout:
                this.showAlertLogout();
                break;
        }
    };

    private showAlertLogout = () => {
        if (this.hasUnmounted === false) {
            this.setState({
                isVisibleAlertLogOut: true,
            });
        }
    };

    private hideAlertLogout = () => {
        if (this.hasUnmounted === false) {
            this.setState({
                isVisibleAlertLogOut: false,
            });
        }
    };

    private handleAvvisoPopup = () => {
        if (this.hasUnmounted === false) {
            this.setState({
                isVisibleAvviso: !this.state.isVisibleAvviso,
            });
        }
    };

    private logout = () => {
        this.hideAlertLogout();
        const accessToken = sessionStorage.getItem(environment.accessTokenName) || "";
        const refreshToken = sessionStorage.getItem(environment.refreshTokenName) || "";
        var requestLogout = new ResponseAuthTokensModel({ accessToken: accessToken, refreshToken: refreshToken });
        this.props.dispatch(UtenteAction.logout(requestLogout));
        this.props.dispatch(UtenteAction.resetAll());
        window.close();
        if (window.closed === false) {
            this.handleAvvisoPopup();
        }
    };

    public render(): JSX.Element | null {
        const { isLogged } = this.props;
        const { isVisibleAlertLogOut, isVisibleAvviso } = this.state;

        const dropdownItems = [
            {
                code: HeaderUtenteOperationEnum.Utente,
                label: this.getUserName(),
                className: "d-xl-none text-muted disabled",
            },
            // {
            //     code: HeaderUtenteOperationEnum.Profilo,
            //     label: "Profilo", //i18n.t("header_lbl_profilo_utente")
            //     icon: IconNameEnum.Utente,
            // },
            {
                code: HeaderUtenteOperationEnum.Logout,
                label: "Logout", //i18n.t("header_lbl_logout")
                icon: IconNameEnum.Logout,
            },
        ];

        return (
            <>
                <Nav>
                    <Col style={{ height: "30%", width: "20%" }} lg={4}>
                        <BaseButton
                            type="button"
                            color="blue"
                            label=""
                            icon={IconNameEnum.UtenteBianco}
                            iconPos="before"
                            className="d-none d-xl-inline-block ml-3 p-3 mt-2 mb-2 cursor-default"
                            circled={true}
                        />
                    </Col>
                    <Col className="border-right px-3 d-none d-xl-inline-block " lg={8}>
                        <small>{"Utente"}</small> {/*{i18n.t("navbar_lbl_user_role")} */}
                        <h5 style={{ fontSize: "100%" }} className="m-0">
                            {this.getUserName()}
                        </h5>
                        <h6 style={{ fontSize: "100%" }} className="m-0">
                            {this.getDescUo()}
                        </h6>
                    </Col>
                    <BaseDropdown
                        items={dropdownItems}
                        onClickHandler={this.onDropdownSelect}
                        customToggleId="main-nav-user-dropdown"
                        className="my-auto"
                    />
                </Nav>
                <BaseModal
                    show={isLogged === true && isVisibleAlertLogOut}
                    onHideHandler={this.hideAlertLogout}
                    closeOnOutClick={false}
                    centered={true}
                    title={"Logout"}
                    body={"Sei sicuro di voler uscire?"}
                    footer={
                        <>
                            <BaseButton
                                type="button"
                                color="grey"
                                label={"No"}
                                icon={IconNameEnum.Ko}
                                onClickHandler={this.hideAlertLogout}
                            />
                            <BaseButton
                                type="button"
                                color="blue"
                                label={"Sì"}
                                icon={IconNameEnum.Ok}
                                onClickHandler={this.logout}
                            />
                        </>
                    }
                />

                <BaseModal
                    show={isVisibleAvviso}
                    onHideHandler={this.hideAlertLogout}
                    closeOnOutClick={false}
                    centered={true}
                    title={"Avviso"}
                    body={
                        <>
                            <h5>Logout effettuato con successo!</h5>
                            <p>Il tab del browser non può essere chiuso automaticamente.</p>
                            <p>Si prega di chiuderlo manualmente.</p>
                        </>
                    }
                    footer={
                        <BaseButton
                            type="button"
                            color="blue"
                            label={"Chiudi"}
                            icon={IconNameEnum.Ok}
                            onClickHandler={this.handleAvvisoPopup}
                        />
                    }
                />
            </>
        );
    }
}

export { HeaderUtente as Unconnected };
export default connect(mapStateToProps)(HeaderUtente);
